import type { LicensedFeature, LicensedFeatures } from "@octopusdeploy/octopus-server-client";
import type { ReactNode } from "react";
import React from "react";
import { repository } from "~/clientInstance";
import BaseComponent from "~/components/BaseComponent/index";
export interface LicensedFeatureVisibilityProps {
    feature: LicensedFeature;
    disabledContent?: ReactNode;
}
interface LicensedFeatureVisibilityState {
    features?: LicensedFeatures;
}
export default class LicensedFeatureVisibility extends BaseComponent<LicensedFeatureVisibilityProps, LicensedFeatureVisibilityState> {
    constructor(props: LicensedFeatureVisibilityProps) {
        super(props);
        this.state = {
            features: undefined,
        };
    }
    async componentDidMount() {
        const enabledFeatures = await repository.Licenses.getFeatures();
        this.setState({ features: enabledFeatures });
    }
    render() {
        if (this.state.features && this.state.features.EnabledFeatures.findIndex((f) => f === this.props.feature) !== -1) {
            return <>{this.props.children}</>;
        }
        if (this.props.disabledContent) {
            return <>{this.props.disabledContent}</>;
        }
        return null;
    }
    static displayName = "LicensedFeatureVisibility";
}
